import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID, RESPONSE_INIT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SsrService {

  setStatusNotFound(){
    this.setStatus(404);
  }

  setStatusNotAvailable(){
    this.setStatus(410);
  }

  setStatusInternalServerError(){
    this.setStatus(500);
  }

  setStatusMovedPermanently(redirectUrl: string) {
    this.response.headers = {
      'Location': redirectUrl,
    };

    this.setStatus(301);
  }

  isPlatformServer(){
    return isPlatformServer(this.platformId);
  }

  isPlatformBrowser(){
    return isPlatformBrowser(this.platformId);
  }

  private setStatus(code: number){
    if(isPlatformServer(this.platformId)){
      
      this.response.status = code;
    }
  }

  constructor(@Optional() @Inject(RESPONSE_INIT) private response: ResponseInit, @Inject(PLATFORM_ID) private platformId: any) { }
}
